import PortalDocument from "./PortalDocument";
import AbstractContainer from "./AbstractContainer";
import ViewerType from "./DataType";
import Exception from "../../shared/exception/Exception";
import Translate from "../../shared/translation/Translate";
import FunctionHelper from "../../shared/helper/FunctionHelper";
import {Archive} from 'libarchive.js/src/libarchive';
import {Attachment} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";

export default class ZipContainer extends AbstractContainer {
	private loadingTask?: Promise<Archive>

	public clean(): void {
		if (FunctionHelper.exists(this.loadingTask)) {
			this.loadingTask = undefined;
		}

		this.data = undefined;
		this.loaded = false;
	}

	public async loadViewerData(portalDocument: PortalDocument, attachment?: Attachment): Promise<Archive> {
		if (!FunctionHelper.exists(this.data)) {
			throw new Exception(Translate.value("errors.files.corrupt", {ns: "message"}));
		}

		if (FunctionHelper.exists(this.loadingTask)) {
			return this.loadingTask!;
		}

		if (this.loaded) {
			return this.data;
		}

		this.loadingTask = new Promise<Archive>(async (resolve, reject) => {
			let fileName: string = portalDocument.getFileName();
			if (FunctionHelper.exists(attachment)) {
				fileName = FunctionHelper.applyValue(attachment?.name, Attachment.getNameDefault());
			}

			try {
				let archive: Archive = await Archive.open(new File([this.data], fileName));
				resolve(archive);
			} catch (exception: any) {
				reject(exception);
			}
		});

		try {
			this.data = await this.loadingTask;
			this.loaded = true;
		} catch (exception: any) {
			let portalException: Exception = new Exception(exception.message);
			portalException.originalException = exception;
			throw portalException;
		}

		return this.loadingTask;
	}

	public async getNumberOfPages() {
		return 1;
	}

	public getType(): ViewerType {
		return ViewerType.ZIP;
	}
}